module.exports = __webpack_public_path__ + "img/22_bohle.40627aa5.jpeg";